import { queryClient } from "@/lib/query";
import { request } from "@/lib/request";
import { NoteVault } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export const useDeleteNoteVault = () => {
  return useMutation({
    mutationFn: async (data: { vaultId: string }) => {
      const res = await request.delete<{ data: NoteVault | void }>(
        `/internal/notes/vaults/${data.vaultId}`,
      );
      queryClient.invalidateQueries({
        queryKey: ["notes", "vaults"],
      });
      return res.data.data;
    },
  });
};
